export default __webpack_public_path__ + "static/media/theslitheringchaos.16ddfd7b.jpg";